import gql from 'graphql-tag'
import fragment from './fragment'

export default gql`
query listCashBooksSettings {
	cashAssist {
		listCashBooksSettings {
			id
			...CashBookSettingsMain
		}
	}
}
${fragment}`
